import React, { useEffect, useState } from 'react';
import api from '../../../utils/api';
import { usePortal } from '../../../context/PortalContext';
import PortalPageShell, { PortalLoading, PortalStatCard } from '../PortalPageShell';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

export default function PortalStudentAcademics() {
  const { student, loading: portalLoading } = usePortal();
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/portal/student/subjects');
        if (!cancelled) setSubjects(res.data?.data ?? []);
      } catch {
        if (!cancelled) setSubjects([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (portalLoading) return <PortalLoading />;

  const s = student;
  return (
    <PortalPageShell title="My Class" description="Class, section, and subjects">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <PortalStatCard label="Class" value={s?.class_name || '—'} />
        <PortalStatCard label="Section" value={s?.section_name || '—'} />
        <PortalStatCard label="Admission No." value={s?.admission_no || '—'} />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Subjects</CardTitle>
        </CardHeader>
        <CardContent>
          {loading ? <PortalLoading /> : (
            <ul className="divide-y divide-border">
              {subjects.map((sub) => (
                <li key={sub.id} className="py-2 flex justify-between text-sm">
                  <span className="font-medium">{sub.name}</span>
                  <span className="text-muted-foreground">{sub.code || ''}</span>
                </li>
              ))}
              {subjects.length === 0 ? <p className="text-muted-foreground text-sm">No subjects listed.</p> : null}
            </ul>
          )}
        </CardContent>
      </Card>
    </PortalPageShell>
  );
}
